"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SimulateClick = void 0;
class SimulateClick {
    constructor() {
        this.simulateClickAttr = 'data-simulate-click';
        this.triggers = [];
        this.init();
        this.observe();
    }
    init() {
        const initElements = document.querySelectorAll(`[${this.simulateClickAttr}]`);
        if (initElements.length) {
            initElements.forEach((element) => {
                var _a;
                const target = (_a = element.getAttribute(this.simulateClickAttr)) !== null && _a !== void 0 ? _a : '';
                if (document.querySelectorAll(target).length) {
                    this.applyOnClickEvent(element, target);
                }
            });
        }
    }
    applyOnClickEvent(element, target) {
        if (this.triggers.includes(element))
            return;
        this.triggers.push(element);
        element.addEventListener('click', (event) => {
            if (event.target instanceof HTMLElement) {
                const targetElements = document.querySelectorAll(target);
                targetElements.forEach((targetElement) => {
                    targetElement.click();
                });
            }
        });
    }
    observe() {
        const container = document.documentElement || document.body;
        const observerOptions = {
            childList: true,
            subtree: true,
            attributeFilter: [this.simulateClickAttr]
        };
        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (mutation.type === "childList") {
                    mutation.addedNodes.forEach((node) => {
                        var _a;
                        if (node instanceof HTMLElement && node.getAttribute(this.simulateClickAttr)) {
                            const target = (_a = node.getAttribute(this.simulateClickAttr)) !== null && _a !== void 0 ? _a : '';
                            this.applyOnClickEvent(node, target);
                        }
                    });
                }
            });
        });
        observer.observe(container, observerOptions);
    }
}
exports.SimulateClick = SimulateClick;
